import { SPECIAL_UI_ACCESS_ORGANIZATION_ID } from "../../../organizations.js";

export const commandType = "SCHEDULE_FLY_TO_WAYPOINT";
export const label = "Fly to waypoint";
export const isAdminOnly = true;
export const isAdvanced = false;
export const organizations = [SPECIAL_UI_ACCESS_ORGANIZATION_ID];
